import { render, staticRenderFns } from "./QualityControlTable.vue?vue&type=template&id=9b1895e0"
import script from "./QualityControlTable.vue?vue&type=script&lang=js"
export * from "./QualityControlTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports